
import { useNavigate } from 'react-router-dom';

export default function FeaturesSection() {
  const navigate = useNavigate();

  const features = [
    {
      icon: 'ri-gift-line',
      title: '商品体験機会',
      description: '新商品を体験していただく機会を提供します。化粧品、家電、食品など多彩なジャンルをご用意。',
      image: 'https://public.readdy.ai/ai/img_res/afb71e6b41f1219cdc8bfc9ff84ba2e1.jpg',
      iconImage: 'https://readdy.ai/api/search-image?query=Colorful%20gift%20box%20with%20ribbon%20and%20sparkles%2C%20product%20samples%20and%20new%20items%20emerging%20from%20box%2C%20vibrant%20and%20exciting%20illustration%20with%20blue%20and%20teal%20colors%2C%20modern%20flat%20design%20style%2C%20white%20simple%20background&width=400&height=400&seq=featureicon1&orientation=squarish'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '謝礼システム',
      description: '条件を満たすレビュー投稿により謝礼をお支払いします。案件により条件が異なりますので、詳細をご確認ください。',
      image: 'https://readdy.ai/api/search-image?query=Digital%20payment%20concept%20with%20smartphone%20showing%20money%20transfer%2C%20coins%20and%20bills%20floating%20around%2C%20modern%20financial%20technology%20illustration%2C%20blue%20and%20green%20color%20scheme%2C%20clean%20background&width=400&height=300&seq=feature2&orientation=landscape',
      iconImage: 'https://readdy.ai/api/search-image?query=Money%20coins%20and%20bills%20with%20dollar%20symbols%2C%20digital%20payment%20icons%2C%20financial%20reward%20concept%20illustration%20with%20green%20and%20teal%20colors%2C%20modern%20flat%20design%20style%2C%20white%20simple%20background&width=400&height=400&seq=featureicon2&orientation=squarish'
    },
    {
      icon: 'ri-home-line',
      title: '在宅で参加可能',
      description: '自宅から参加可能で、自分のペースで活動できます。家事や育児の合間に、スキマ時間を活用できます。',
      image: 'https://readdy.ai/api/search-image?query=Cozy%20home%20workspace%20with%20woman%20writing%20product%20review%20on%20laptop%2C%20comfortable%20living%20room%20setting%20with%20natural%20light%2C%20plants%20and%20coffee%20cup%2C%20peaceful%20work-from-home%20atmosphere&width=400&height=300&seq=feature3&orientation=landscape',
      iconImage: 'https://readdy.ai/api/search-image?query=Cozy%20home%20interior%20with%20comfortable%20furniture%2C%20laptop%20on%20desk%2C%20plants%20and%20warm%20lighting%2C%20work%20from%20home%20concept%20illustration%20with%20orange%20and%20warm%20colors%2C%20modern%20flat%20design%20style%2C%20white%20simple%20background&width=400&height=400&seq=featureicon3&orientation=squarish'
    },
    {
      icon: 'ri-shield-check-line',
      title: '安心・安全',
      description: '厳選された企業の商品のみを扱い、個人情報保護も万全。初心者でも安心してご利用いただけます。',
      image: 'https://readdy.ai/api/search-image?query=Security%20and%20trust%20concept%20with%20shield%20icon%2C%20verified%20checkmarks%2C%20and%20professional%20certification%20symbols%2C%20clean%20modern%20design%20with%20blue%20and%20white%20colors%2C%20representing%20safety%20and%20reliability&width=400&height=300&seq=feature4&orientation=landscape',
      iconImage: 'https://readdy.ai/api/search-image?query=Security%20shield%20with%20checkmark%20and%20lock%20symbols%2C%20protection%20and%20safety%20concept%20illustration%20with%20blue%20and%20indigo%20colors%2C%20modern%20flat%20design%20style%2C%20white%20simple%20background&width=400&height=400&seq=featureicon4&orientation=squarish'
    },
    {
      icon: 'ri-time-line',
      title: '柔軟なスケジュール',
      description: '期限は余裕を持って設定しています。あなたのライフスタイルに合わせて無理なく続けられます。',
      image: 'https://readdy.ai/api/search-image?query=Flexible%20schedule%20concept%20with%20calendar%2C%20clock%2C%20and%20person%20relaxing%20while%20working%20on%20laptop%2C%20work-life%20balance%20illustration%2C%20soft%20pastel%20colors%2C%20comfortable%20home%20environment&width=400&height=300&seq=feature5&orientation=landscape',
      iconImage: 'https://readdy.ai/api/search-image?query=Clock%20and%20calendar%20with%20flexible%20time%20management%20symbols%2C%20work-life%20balance%20concept%20illustration%20with%20purple%20and%20violet%20colors%2C%20modern%20flat%20design%20style%2C%20white%20simple%20background&width=400&height=400&seq=featureicon5&orientation=squarish'
    },
    {
      icon: 'ri-community-line',
      title: 'サポート充実',
      description: '専属スタッフがあなたをしっかりサポート。困った時はいつでもお気軽にご相談ください。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20customer%20support%20team%20helping%20users%2C%20friendly%20Japanese%20staff%20providing%20assistance%20through%20chat%20and%20phone%2C%20professional%20office%20environment%20with%20modern%20technology%2C%20collaborative%20and%20helpful%20atmosphere%2C%20Asian%20features%2C%20Japanese%20business%20setting&width=400&height=300&seq=feature6&orientation=landscape',
      iconImage: 'https://readdy.ai/api/search-image?query=Friendly%20customer%20support%20team%20with%20headsets%2C%20helping%20hands%20and%20communication%20symbols%2C%20support%20and%20assistance%20concept%20illustration%20with%20pink%20and%20rose%20colors%2C%20modern%20flat%20design%20style%2C%20white%20simple%20background&width=400&height=400&seq=featureicon6&orientation=squarish'
    }
  ];

  const scrollToApplication = () => {
    const element = document.getElementById('application-form-title');
    if (element) {
      const headerHeight = 80;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="features" className="py-12 sm:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            なぜモニター友の会が選ばれるのか
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            私たちは商品モニターの皆様が安心して、楽しく活動できる環境を提供しています
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-4 sm:p-8 hover:shadow-xl transition-shadow duration-300">
              <div className="mb-4 sm:mb-6">
                <img 
                  src={feature.image} 
                  alt={feature.title}
                  className="w-full h-32 sm:h-48 object-cover rounded-lg mb-3 sm:mb-4"
                />
                <img 
                  src={feature.iconImage} 
                  alt={feature.title}
                  className="w-24 h-24 object-cover rounded-xl"
                />
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">
                {feature.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* 中腹CTA（信頼/特典の直後） */}
        <div className="mt-12 sm:mt-16 text-center bg-blue-50 rounded-2xl p-4 sm:p-8">
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
            安心の環境で商品モニターを始めませんか？
          </h3>
          <p className="text-sm sm:text-base text-gray-600 mb-6">
            厳選された商品と充実したサポートで、あなたの商品モニター活動をお手伝いします
          </p>
          <button
            onClick={scrollToApplication}
            className="bg-teal-600 text-white px-8 py-3 rounded-lg hover:bg-teal-700 transition-colors flex items-center whitespace-nowrap cursor-pointer mx-auto"
          >
            <i className="ri-gift-line mr-2"></i>
            商品モニター会員応募
          </button>
        </div>
      </div>
    </section>
  );
}
